import { render, staticRenderFns } from "./bookinfoRepository2.vue?vue&type=template&id=96c9bbee&scoped=true&"
import script from "./bookinfoRepository2.vue?vue&type=script&lang=js&"
export * from "./bookinfoRepository2.vue?vue&type=script&lang=js&"
import style0 from "./bookinfoRepository2.vue?vue&type=style&index=0&id=96c9bbee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c9bbee",
  null
  
)

export default component.exports